import { EditorView } from "@codemirror/view";

export const disassemblyTheme = EditorView.theme({
    "&": {
        maxHeight: "100%"
    },
});
